import 'css-chunksrc/client/scenes/optimizedGantt/detailsView/details/progress/styles.scss';export default {
  "details": "_details_5uvtr_1",
  "list": "_list_5uvtr_16",
  "block": "_block_5uvtr_20",
  "calendar": "_calendar_5uvtr_32",
  "text": "_text_5uvtr_41",
  "project": "_project_5uvtr_49",
  "closedCalendar": "_closedCalendar_5uvtr_57"
};